import App from "./App";
import { createRoot } from "react-dom/client";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { HelmetProvider } from "react-helmet-async";
import "nprogress/nprogress.css";
import { AUTH_CONFIG } from "../src/auth/auth0-variables";
import ThemeProvider1 from "./theme/ThemeProvider";
import { Auth0Provider } from "@auth0/auth0-react";

createRoot(document.getElementById("root")).render(
  <HelmetProvider>
    <ThemeProvider1>
      <Auth0Provider
        domain={AUTH_CONFIG.domain}
        clientId={AUTH_CONFIG.clientId}
        authorizationParams={{
          redirect_uri: AUTH_CONFIG.callbackUrl,
          audience: "https://www.skypad-node-api.com",
          scope: "openid profile email"
        }}
      >
        <App />
      </Auth0Provider>
    </ThemeProvider1>
  </HelmetProvider>
);

serviceWorkerRegistration.register();
